
import { mapState, mapActions } from "vuex";
export default {
  beforeMount() {
    this.selectedPlan =
      this.locationDetails.latest_active_restaurant_plan?.app_subscriptions_plan_id;
    this.planLoading = true;
    this.getSubscriptionPlans()
      .then(() => {})
      .finally(() => {
        this.planLoading = false;
      });
  },
  data() {
    return {
      loading: false,
      planLoading: false,
      selectedPlan: null
    };
  },
  computed: {
    ...mapState("restaurant", [
      "locationDetails",
      "subscription",
      "subscriptionPlans"
    ]),
    isDisabled() {
      return !(this.selectedPlan === "2");
    }
  },
  methods: {
    ...mapActions("restaurant", [
      "createSubscription",
      "cancelSubscription",
      "getSubscriptionPlans"
    ]),
    handleChangePlan() {
      this.loading = true;
      this.createSubscription({
        location_id: this.locationDetails.id,
        plan_id: this.selectedPlan
      }).then(({ data }) => {
        this.$nuxt.$emit("show-toast", {
          text: "Subscription plan updated successfully",
          color: "success darken-2",
          icon: "done",
          flat: true
        });
        this.loading = false;
      });
    }
  }
};
